 /**
 * @name InfoBox
 * @version 1.1.13 [March 19, 2014]
 * @author Gary Little (inspired by proof-of-concept code from Pamela Fox of Google)
 * @copyright Copyright 2010 Gary Little [gary at luxcentral.com]
 * @fileoverview InfoBox extends the Google Maps JavaScript API V3 <tt>OverlayView</tt> class.
 *  <p>
 *  An InfoBox behaves like a <tt>google.maps.InfoWindow</tt>, but it supports several
 *  additional properties for advanced styling. An InfoBox can also be used as a map label.
 *  <p>
 *  An InfoBox also fires the same events as a <tt>google.maps.InfoWindow</tt>.
 */

/*!
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*jslint browser:true */
/*global google */

/**
 * @name InfoBoxOptions
 * @class This class represents the optional parameter passed to the {@link InfoBox} constructor.
 * @property {string|Node} content The content of the InfoBox (plain text or an HTML DOM node).
 * @property {boolean} [disableAutoPan=false] Disable auto-pan on <tt>open</tt>.
 * @property {number} maxWidth The maximum width (in pixels) of the InfoBox. Set to 0 if no maximum.
 * @property {Size} pixelOffset The offset (in pixels) from the top left corner of the InfoBox
 *  (or the bottom left corner if the <code>alignBottom</code> property is <code>true</code>)
 *  to the map pixel corresponding to <tt>position</tt>.
 * @property {LatLng} position The geographic location at which to display the InfoBox.
 * @property {number} zIndex The CSS z-index style value for the InfoBox.
 *  Note: This value overrides a zIndex setting specified in the <tt>boxStyle</tt> property.
 * @property {string} [boxClass="infoBox"] The name of the CSS class defining the styles for the InfoBox container.
 * @property {Object} [boxStyle] An object literal whose properties define specific CSS
 *  style values to be applied to the InfoBox. Style values defined here override those that may
 *  be defined in the <code>boxClass</code> style sheet. If this property is changed after the
 *  InfoBox has been created, all previously set styles (except those defined in the style sheet)
 *  are removed from the InfoBox before the new style values are applied.
 * @property {string} closeBoxMargin The CSS margin style value for the close box.
 *  The default is "2px" (a 2-pixel margin on all sides).
 * @property {string} closeBoxURL The URL of the image representing the close box.
 *  Note: The default is the URL for Google's standard close box.
 *  Set this property to "" if no close box is required.
 * @property {Size} infoBoxClearance Minimum offset (in pixels) from the InfoBox to the
 *  map edge after an auto-pan.
 * @property {boolean} [isHidden=false] Hide the InfoBox on <tt>open</tt>.
 *  [Deprecated in favor of the <tt>visible</tt> property.]
 * @property {boolean} [visible=true] Show the InfoBox on <tt>open</tt>.
 * @property {boolean} alignBottom Align the bottom left corner of the InfoBox to the <code>position</code>
 *  location (default is <tt>false</tt> which means that the top left corner of the InfoBox is aligned).
 * @property {string} pane The pane where the InfoBox is to appear (default is "floatPane").
 *  Set the pane to "mapPane" if the InfoBox is being used as a map label.
 *  Valid pane names are the property names for the <tt>google.maps.MapPanes</tt> object.
 * @property {boolean} enableEventPropagation Propagate mousedown, mousemove, mouseover, mouseout,
 *  mouseup, click, dblclick, touchstart, touchend, touchmove, and contextmenu events in the InfoBox
 *  (default is <tt>false</tt> to mimic the behavior of a <tt>google.maps.InfoWindow</tt>). Set
 *  this property to <tt>true</tt> if the InfoBox is being used as a map label.
 */

$(document).ready(function() {
	if($('.GPC0108').length == 0) return false;
	var $cont = $('.GPC0108');

	/* LGEGMC-2368 Start */
	if($('.GPC0117').length > 0){
		var com_id = $cont.closest("div .iw_component").attr("id");
		$(".GPC0117").find("li a[href='#"+com_id+"']").addClass("where-to-buy").attr("data-link-name","where_to_buy");		
	}
	/* LGEGMC-2368 End */
	
	// find-locally
	if($cont.find('.find-locally').length > 0) {

		$cont.find('.find-locally').each(function() {
			var obj = $(this).find('.map-container');
			// LGEAF-136 Start
			if($cont.find('#multiBrandShopImprovingFlag').val() == 'Y'){
				obj.closest('.find-locally').addClass('has-search has-category no-tab');
			}else if($cont.find('#brandShopImprovingFlag').val() == 'Y') {
				obj.closest('.find-locally').addClass('has-search no-tab');
            }                    
			// LGEAF-136 End
			//if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
				obj.closest('.find-locally').addClass('active');
			//} else {
			//	obj.parent().find('.searchbox-wrap').remove();
			//	obj.parent().find('.search-results').remove();
			//	ePrivacyCookies.view('load', '', obj);
			//	obj.css('background', '#fff');
			//	obj.closest('.find-locally').addClass('active');
			//	return false;
			//}
		});

		// google map
		window.initialize = function() {

			// infoBox
			{
				function InfoBox(opt_opts) {
					opt_opts = opt_opts || {};
					google.maps.OverlayView.apply(this, arguments);
					// Standard options (in common with google.maps.InfoWindow):
					//
					this.content_ = opt_opts.content || "";
					this.disableAutoPan_ = opt_opts.disableAutoPan || false;
					this.maxWidth_ = opt_opts.maxWidth || 0;
					this.pixelOffset_ = opt_opts.pixelOffset || new google.maps.Size(0, 0);
					this.position_ = opt_opts.position || new google.maps.LatLng(0, 0);
					this.zIndex_ = opt_opts.zIndex || null;

					// Additional options (unique to InfoBox):
					//
					this.boxClass_ = opt_opts.boxClass || "infoBox";
					this.boxStyle_ = opt_opts.boxStyle || {};
					this.closeBoxMargin_ = opt_opts.closeBoxMargin || "2px";
					this.closeBoxURL_ = opt_opts.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif";
					if (opt_opts.closeBoxURL === "") {
						this.closeBoxURL_ = "";
					}
					this.infoBoxClearance_ = opt_opts.infoBoxClearance || new google.maps.Size(1, 1);

					if (typeof opt_opts.visible === "undefined") {
						if (typeof opt_opts.isHidden === "undefined") {
							opt_opts.visible = true;
						} else {
							opt_opts.visible = !opt_opts.isHidden;
						}
					}
					this.isHidden_ = !opt_opts.visible;

					this.alignBottom_ = opt_opts.alignBottom || false;
					this.pane_ = opt_opts.pane || "floatPane";
					this.enableEventPropagation_ = opt_opts.enableEventPropagation || false;

					this.div_ = null;
					this.closeListener_ = null;
					this.moveListener_ = null;
					this.contextListener_ = null;
					this.eventListeners_ = null;
					this.fixedWidthSet_ = null;
				}

				/* InfoBox extends OverlayView in the Google Maps API v3.
				 */
				InfoBox.prototype = new google.maps.OverlayView();

				/**
				 * Creates the DIV representing the InfoBox.
				 * @private
				 */
				InfoBox.prototype.createInfoBoxDiv_ = function() {

					var i;
					var events;
					var bw;
					var me = this;

					// This handler prevents an event in the InfoBox from being passed on to the map.
					//
					var cancelHandler = function(e) {
						e.cancelBubble = true;
						if (e.stopPropagation) {
							e.stopPropagation();
						}
					};

					// This handler ignores the current event in the InfoBox and conditionally prevents
					// the event from being passed on to the map. It is used for the contextmenu event.
					//
					var ignoreHandler = function(e) {

						e.returnValue = false;

						if (e.preventDefault) {

							e.preventDefault();
						}

						if (!me.enableEventPropagation_) {

							cancelHandler(e);
						}
					};

					if (!this.div_) {

						this.div_ = document.createElement("div");

						this.setBoxStyle_();

						if (typeof this.content_.nodeType === "undefined") {
							this.div_.innerHTML = this.getCloseBoxImg_() + this.content_;
						} else {
							this.div_.innerHTML = this.getCloseBoxImg_();
							this.div_.appendChild(this.content_);
						}

						// Add the InfoBox DIV to the DOM
						this.getPanes()[this.pane_].appendChild(this.div_);

						this.addClickHandler_();

						if (this.div_.style.width) {

							this.fixedWidthSet_ = true;

						} else {

							if (this.maxWidth_ !== 0 && this.div_.offsetWidth > this.maxWidth_) {

								this.div_.style.width = this.maxWidth_;
								this.div_.style.overflow = "auto";
								this.fixedWidthSet_ = true;

							} else { // The following code is needed to overcome problems with MSIE

								bw = this.getBoxWidths_();

								this.div_.style.width = (this.div_.offsetWidth - bw.left - bw.right) + "px";
								this.fixedWidthSet_ = false;
							}
						}

						this.panBox_(this.disableAutoPan_);

						if (!this.enableEventPropagation_) {

							this.eventListeners_ = [];

							// Cancel event propagation.
							//
							// Note: mousemove not included (to resolve Issue 152)
							events = ["mousedown", "mouseover", "mouseout", "mouseup",
								"click", "dblclick", "touchstart", "touchend", "touchmove"
							];

							for (i = 0; i < events.length; i++) {

								this.eventListeners_.push(google.maps.event.addDomListener(this.div_, events[i], cancelHandler));
							}

							// Workaround for Google bug that causes the cursor to change to a pointer
							// when the mouse moves over a marker underneath InfoBox.
							this.eventListeners_.push(google.maps.event.addDomListener(this.div_, "mouseover", function(e) {
								this.style.cursor = "default";
							}));
						}

						this.contextListener_ = google.maps.event.addDomListener(this.div_, "contextmenu", ignoreHandler);

						/**
						 * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
						 * @name InfoBox#domready
						 * @event
						 */
						google.maps.event.trigger(this, "domready");
					}
				};

				/**
				 * Returns the HTML <IMG> tag for the close box.
				 * @private
				 */
				InfoBox.prototype.getCloseBoxImg_ = function() {

					var img = "";

					if (this.closeBoxURL_ !== "") {

						img = "<a href='#none' class='window-close' id='infoWindowClose'><div class='sr-only'>close</div></a>";
					}

					return img;
				};

				/**
				 * Adds the click handler to the InfoBox close box.
				 * @private
				 */
				InfoBox.prototype.addClickHandler_ = function() {

					var closeBox;

					if (this.closeBoxURL_ !== "") {

						closeBox = this.div_.firstChild;
						this.closeListener_ = google.maps.event.addDomListener(closeBox, "click", this.getCloseClickHandler_());

					} else {

						this.closeListener_ = null;
					}
				};

				/**
				 * Returns the function to call when the user clicks the close box of an InfoBox.
				 * @private
				 */
				InfoBox.prototype.getCloseClickHandler_ = function() {

					var me = this;

					return function(e) {

						// 1.0.3 fix: Always prevent propagation of a close box click to the map:
						e.cancelBubble = true;

						if (e.stopPropagation) {

							e.stopPropagation();
						}

						/**
						 * This event is fired when the InfoBox's close box is clicked.
						 * @name InfoBox#closeclick
						 * @event
						 */
						google.maps.event.trigger(me, "closeclick");

						me.close();
					};
				};

				/**
				 * Pans the map so that the InfoBox appears entirely within the map's visible area.
				 * @private
				 */
				InfoBox.prototype.panBox_ = function(disablePan) {

					var map;
					var bounds;
					var xOffset = 0,
						yOffset = 0;

					if (!disablePan) {

						map = this.getMap();

						if (map instanceof google.maps.Map) { // Only pan if attached to map, not panorama

							if (!map.getBounds().contains(this.position_)) {
								// Marker not in visible area of map, so set center
								// of map to the marker position first.
								map.setCenter(this.position_);
							}

							bounds = map.getBounds();

							var mapDiv = map.getDiv();
							var mapWidth = mapDiv.offsetWidth;
							var mapHeight = mapDiv.offsetHeight;
							var iwOffsetX = this.pixelOffset_.width;
							var iwOffsetY = this.pixelOffset_.height;
							var iwWidth = this.div_.offsetWidth;
							var iwHeight = this.div_.offsetHeight;
							var padX = this.infoBoxClearance_.width;
							var padY = this.infoBoxClearance_.height;
							var pixPosition = this.getProjection().fromLatLngToContainerPixel(this.position_);

							if (pixPosition.x < (-iwOffsetX + padX)) {
								xOffset = pixPosition.x + iwOffsetX - padX;
							} else if ((pixPosition.x + iwWidth + iwOffsetX + padX) > mapWidth) {
								xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
							}
							if (this.alignBottom_) {
								if (pixPosition.y < (-iwOffsetY + padY + iwHeight)) {
									yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
								} else if ((pixPosition.y + iwOffsetY + padY) > mapHeight) {
									yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
								}
							} else {
								if (pixPosition.y < (-iwOffsetY + padY)) {
									yOffset = pixPosition.y + iwOffsetY - padY;
								} else if ((pixPosition.y + iwHeight + iwOffsetY + padY) > mapHeight) {
									yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
								}
							}

							if (!(xOffset === 0 && yOffset === 0)) {

								// Move the map to the shifted center.
								//
								var c = map.getCenter();
								map.panBy(xOffset, yOffset);
							}
						}
					}
				};

				/**
				 * Sets the style of the InfoBox by setting the style sheet and applying
				 * other specific styles requested.
				 * @private
				 */
				InfoBox.prototype.setBoxStyle_ = function() {

					var i, boxStyle;

					if (this.div_) {

						// Apply style values from the style sheet defined in the boxClass parameter:
						this.div_.className = this.boxClass_;

						// Clear existing inline style values:
						this.div_.style.cssText = "";

						// Apply style values defined in the boxStyle parameter:
						boxStyle = this.boxStyle_;
						for (i in boxStyle) {

							if (boxStyle.hasOwnProperty(i)) {

								this.div_.style[i] = boxStyle[i];
							}
						}

						// Fix for iOS disappearing InfoBox problem.
						// See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
						this.div_.style.WebkitTransform = "translateZ(0)";

						// Fix up opacity style for benefit of MSIE:
						//
						if (typeof this.div_.style.opacity !== "undefined" && this.div_.style.opacity !== "") {
							// See http://www.quirksmode.org/css/opacity.html
							this.div_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(Opacity=" + (this.div_.style.opacity * 100) + ")\"";
							this.div_.style.filter = "alpha(opacity=" + (this.div_.style.opacity * 100) + ")";
						}

						// Apply required styles:
						//
						this.div_.style.position = "absolute";
						this.div_.style.visibility = 'hidden';
						if (this.zIndex_ !== null) {

							this.div_.style.zIndex = this.zIndex_;
						}
					}
				};

				/**
				 * Get the widths of the borders of the InfoBox.
				 * @private
				 * @return {Object} widths object (top, bottom left, right)
				 */
				InfoBox.prototype.getBoxWidths_ = function() {

					var computedStyle;
					var bw = {
						top: 0,
						bottom: 0,
						left: 0,
						right: 0
					};
					var box = this.div_;

					if (document.defaultView && document.defaultView.getComputedStyle) {

						computedStyle = box.ownerDocument.defaultView.getComputedStyle(box, "");

						if (computedStyle) {

							// The computed styles are always in pixel units (good!)
							bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0;
							bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
							bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0;
							bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0;
						}

					} else if (document.documentElement.currentStyle) { // MSIE

						if (box.currentStyle) {

							// The current styles may not be in pixel units, but assume they are (bad!)
							bw.top = parseInt(box.currentStyle.borderTopWidth, 10) || 0;
							bw.bottom = parseInt(box.currentStyle.borderBottomWidth, 10) || 0;
							bw.left = parseInt(box.currentStyle.borderLeftWidth, 10) || 0;
							bw.right = parseInt(box.currentStyle.borderRightWidth, 10) || 0;
						}
					}

					return bw;
				};

				/**
				 * Invoked when <tt>close</tt> is called. Do not call it directly.
				 */
				InfoBox.prototype.onRemove = function() {

					if (this.div_) {

						this.div_.parentNode.removeChild(this.div_);
						this.div_ = null;
					}
				};

				/**
				 * Draws the InfoBox based on the current map projection and zoom level.
				 */
				InfoBox.prototype.draw = function() {

					this.createInfoBoxDiv_();

					var pixPosition = this.getProjection().fromLatLngToDivPixel(this.position_);

					this.div_.style.left = (pixPosition.x + this.pixelOffset_.width) + "px";

					if (this.alignBottom_) {
						this.div_.style.bottom = -(pixPosition.y + this.pixelOffset_.height) + "px";
					} else {
						this.div_.style.top = (pixPosition.y + this.pixelOffset_.height) + "px";
					}

					if (this.isHidden_) {

						this.div_.style.visibility = "hidden";

					} else {

						this.div_.style.visibility = "visible";
					}
				};

				/**
				 * Sets the options for the InfoBox. Note that changes to the <tt>maxWidth</tt>,
				 *  <tt>closeBoxMargin</tt>, <tt>closeBoxURL</tt>, and <tt>enableEventPropagation</tt>
				 *  properties have no affect until the current InfoBox is <tt>close</tt>d and a new one
				 *  is <tt>open</tt>ed.
				 * @param {InfoBoxOptions} opt_opts
				 */
				InfoBox.prototype.setOptions = function(opt_opts) {
					if (typeof opt_opts.boxClass !== "undefined") { // Must be first

						this.boxClass_ = opt_opts.boxClass;
						this.setBoxStyle_();
					}
					if (typeof opt_opts.boxStyle !== "undefined") { // Must be second

						this.boxStyle_ = opt_opts.boxStyle;
						this.setBoxStyle_();
					}
					if (typeof opt_opts.content !== "undefined") {

						this.setContent(opt_opts.content);
					}
					if (typeof opt_opts.disableAutoPan !== "undefined") {

						this.disableAutoPan_ = opt_opts.disableAutoPan;
					}
					if (typeof opt_opts.maxWidth !== "undefined") {

						this.maxWidth_ = opt_opts.maxWidth;
					}
					if (typeof opt_opts.pixelOffset !== "undefined") {

						this.pixelOffset_ = opt_opts.pixelOffset;
					}
					if (typeof opt_opts.alignBottom !== "undefined") {

						this.alignBottom_ = opt_opts.alignBottom;
					}
					if (typeof opt_opts.position !== "undefined") {

						this.setPosition(opt_opts.position);
					}
					if (typeof opt_opts.zIndex !== "undefined") {

						this.setZIndex(opt_opts.zIndex);
					}
					if (typeof opt_opts.closeBoxMargin !== "undefined") {

						this.closeBoxMargin_ = opt_opts.closeBoxMargin;
					}
					if (typeof opt_opts.closeBoxURL !== "undefined") {

						this.closeBoxURL_ = opt_opts.closeBoxURL;
					}
					if (typeof opt_opts.infoBoxClearance !== "undefined") {

						this.infoBoxClearance_ = opt_opts.infoBoxClearance;
					}
					if (typeof opt_opts.isHidden !== "undefined") {

						this.isHidden_ = opt_opts.isHidden;
					}
					if (typeof opt_opts.visible !== "undefined") {

						this.isHidden_ = !opt_opts.visible;
					}
					if (typeof opt_opts.enableEventPropagation !== "undefined") {

						this.enableEventPropagation_ = opt_opts.enableEventPropagation;
					}

					if (this.div_) {

						this.draw();
					}
				};

				/**
				 * Sets the content of the InfoBox.
				 *  The content can be plain text or an HTML DOM node.
				 * @param {string|Node} content
				 */
				InfoBox.prototype.setContent = function(content) {
					this.content_ = content;

					if (this.div_) {

						if (this.closeListener_) {

							google.maps.event.removeListener(this.closeListener_);
							this.closeListener_ = null;
						}

						// Odd code required to make things work with MSIE.
						//
						if (!this.fixedWidthSet_) {

							this.div_.style.width = "";
						}

						if (typeof content.nodeType === "undefined") {
							this.div_.innerHTML = this.getCloseBoxImg_() + content;
						} else {
							this.div_.innerHTML = this.getCloseBoxImg_();
							this.div_.appendChild(content);
						}

						// Perverse code required to make things work with MSIE.
						// (Ensures the close box does, in fact, float to the right.)
						//
						if (!this.fixedWidthSet_) {
							this.div_.style.width = this.div_.offsetWidth + "px";
							if (typeof content.nodeType === "undefined") {
								this.div_.innerHTML = this.getCloseBoxImg_() + content;
							} else {
								this.div_.innerHTML = this.getCloseBoxImg_();
								this.div_.appendChild(content);
							}
						}

						this.addClickHandler_();
					}

					/**
					 * This event is fired when the content of the InfoBox changes.
					 * @name InfoBox#content_changed
					 * @event
					 */
					google.maps.event.trigger(this, "content_changed");
				};

				/**
				 * Sets the geographic location of the InfoBox.
				 * @param {LatLng} latlng
				 */
				InfoBox.prototype.setPosition = function(latlng) {

					this.position_ = latlng;

					if (this.div_) {

						this.draw();
					}

					/**
					 * This event is fired when the position of the InfoBox changes.
					 * @name InfoBox#position_changed
					 * @event
					 */
					google.maps.event.trigger(this, "position_changed");
				};

				/**
				 * Sets the zIndex style for the InfoBox.
				 * @param {number} index
				 */
				InfoBox.prototype.setZIndex = function(index) {

					this.zIndex_ = index;

					if (this.div_) {

						this.div_.style.zIndex = index;
					}

					/**
					 * This event is fired when the zIndex of the InfoBox changes.
					 * @name InfoBox#zindex_changed
					 * @event
					 */
					google.maps.event.trigger(this, "zindex_changed");
				};

				/**
				 * Sets the visibility of the InfoBox.
				 * @param {boolean} isVisible
				 */
				InfoBox.prototype.setVisible = function(isVisible) {

					this.isHidden_ = !isVisible;
					if (this.div_) {
						this.div_.style.visibility = (this.isHidden_ ? "hidden" : "visible");
					}
				};

				/**
				 * Returns the content of the InfoBox.
				 * @returns {string}
				 */
				InfoBox.prototype.getContent = function() {

					return this.content_;
				};

				/**
				 * Returns the geographic location of the InfoBox.
				 * @returns {LatLng}
				 */
				InfoBox.prototype.getPosition = function() {
					return this.position_;
				};

				/**
				 * Returns the zIndex for the InfoBox.
				 * @returns {number}
				 */
				InfoBox.prototype.getZIndex = function() {

					return this.zIndex_;
				};

				/**
				 * Returns a flag indicating whether the InfoBox is visible.
				 * @returns {boolean}
				 */
				InfoBox.prototype.getVisible = function() {

					var isVisible;

					if ((typeof this.getMap() === "undefined") || (this.getMap() === null)) {
						isVisible = false;
					} else {
						isVisible = !this.isHidden_;
					}
					return isVisible;
				};

				/**
				 * Shows the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
				 */
				InfoBox.prototype.show = function() {

					this.isHidden_ = false;
					if (this.div_) {
						this.div_.style.visibility = "visible";
					}
				};

				/**
				 * Hides the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
				 */
				InfoBox.prototype.hide = function() {

					this.isHidden_ = true;
					if (this.div_) {
						this.div_.style.visibility = "hidden";
					}
				};

				/**
				 * Adds the InfoBox to the specified map or Street View panorama. If <tt>anchor</tt>
				 *  (usually a <tt>google.maps.Marker</tt>) is specified, the position
				 *  of the InfoBox is set to the position of the <tt>anchor</tt>. If the
				 *  anchor is dragged to a new location, the InfoBox moves as well.
				 * @param {Map|StreetViewPanorama} map
				 * @param {MVCObject} [anchor]
				 */
				InfoBox.prototype.open = function(map, anchor) {

					var me = this;

					if (anchor) {
						this.position_ = anchor.getPosition();
						this.moveListener_ = google.maps.event.addListener(anchor, "position_changed", function() {
							me.setPosition(this.getPosition());
						});
					}

					this.setMap(map);

					if (this.div_) {

						this.panBox_();
					}
				};

				/**
				 * Removes the InfoBox from the map.
				 */
				InfoBox.prototype.close = function() {

					var i;

					if (this.closeListener_) {

						google.maps.event.removeListener(this.closeListener_);
						this.closeListener_ = null;
					}

					if (this.eventListeners_) {

						for (i = 0; i < this.eventListeners_.length; i++) {

							google.maps.event.removeListener(this.eventListeners_[i]);
						}
						this.eventListeners_ = null;
					}

					if (this.moveListener_) {

						google.maps.event.removeListener(this.moveListener_);
						this.moveListener_ = null;
					}

					if (this.contextListener_) {

						google.maps.event.removeListener(this.contextListener_);
						this.contextListener_ = null;
					}

					this.setMap(null);
				};

				//return InfoBox;

			};

			// theJ
			// LGEGMC-2455 start
			var selectedMarker = null;
			var resetIcon = null;
			var clickIcon = null;
			// LGEGMC-2455 end
			var firstTime = true; // REQ-048
			var firstLoadAllShop = true;	// LGEEG-399
			var GoogleMaps = {
				options: {
					country: null,
					zoomLevel: 5,
					zoomLevelMin: 2,
					zoomLevelMax: 24,
					viewport: null,
					queryZoomLevel: 10,
					queryUrl: $('#storeSearchForm').attr('action'),
					queryType: "json",
					unitMetric: true,
					useDirection: false,
					centerLatitude: null,
					centerLongitude: null,
					defaultLatitude: $('.find-locally').data('default-latitude'), // REQ-048
					defaultLongitude: $('.find-locally').data('default-longitude'), // REQ-048
					autoSubmit: $('.find-locally').data('default-submit'),
					//defaultZoom: $('.find-locally').data('default-zoomlevel'),
					defaultZoom: 10,
					useController: false,
					debug: false
				},
				_init : function() {
					var self = this;
					self.$localStore = $(".find-locally");
					self.$searchForm = self.$localStore.find('.searchbox form');
					self.$storeSection = self.$localStore.find('.information-on-map');
					self.$toggleBtn = self.$localStore.find('.btn-collapse');
					self.$resultBox = self.$localStore.find('.result-box');
					self.$directionBox = self.$localStore.find('.direction-box');
					self.$brandList = self.$localStore.find("#brandResult .result-list");
					self.$searchInput = self.$localStore.find('#mapSearch');
					self.$storeSearchForm = self.$localStore.find('#storeSearchForm');
					self.$resultLocation = self.$localStore.find('.search-location'); // select a location 텍스트 영역
					self.$directionsForm = self.$localStore.find('#directionForm');
					self.$storeMapArea = self.$localStore.find('#storeMap');
					self.$countryCombo = self.$localStore.find('#countryList');
					self.$stepCity = self.$localStore.find('select[name=stepCity]');
					self.$routeList = self.$localStore.find("#directionRoute");

					self.locaitonKey = document.getElementById("startInput");
					// 20200421 START 박지영 - 5차 국가 관련 스크립트 반영
					self.hasSearchInput = self.$localStore.find('#mapSearch').length;
					// 20200421 END
					self.hasSearchSubmit = (self.$localStore.find('.searchbox-wrap .select-box button[type=submit]').length>0) ? true:false;

					self.$defaultMsg = self.$resultBox.find(".default-msg");
					self.$noItems = self.$resultBox.find(".no-items");
					self.$btnArea = self.$resultBox.find(".btn-area");

					self.$locationBtn = self.$localStore.find('button.location');

					self.templateList = self.$brandList.find('template.list').clone().html();
					self.templateMap = self.$brandList.find('template.map').clone().html();

					//var $tempCountry = self.$localStore.data("country").split("_")[0] || $("html").data("countrycode").split("_")[0];
			        //self.options.country = $tempCountry.length == 2 ? $tempCountry : self.$countryCombo.find(":selected").val();
					self.options.country = (self.$localStore.data("country")) ? self.$localStore.data("country") : null;

					self.geoResult = {};
					self.markers = [];
					self.stores = [];
					self.activeItem;
					self.searchHandle = false;
					self.distance = self.options.distance;
					self.afterControl = false;
					self.openDirection = false; // if true, direction mode

					self.timing = {
						queryTimeout: null
					};
					self.markerIcon = {
						size: new google.maps.Size(30, 43),
						anchor: new google.maps.Point(19, 54)
					}

					// 20200409 START 박지영 : country가 있거나 기본 위치가 있으면 맵 실행
					if(self.options.country != null || (self.options.defaultLatitude && self.options.defaultLongitude)) {
						self.mapSetting();
					}
					// 20200409 END

					$('.GPC0108').on('click', '.get-direction', function(e) {
						e.preventDefault();
						self.openDirection = true;

						// for design
						self.$resultBox.removeClass('active');
						self.$directionBox.addClass('active');
						// 20200421 START 박지영 - 삭제
						// 20200421 END
						self.$localStore.find('.search-results .search-area.type-direction').addClass('active');

						// layer on map
						$(this).closest('.list-box').find('.view-detail-map').trigger('click');

						// address
						var address = $(this).closest('.btns').siblings('.address').text();
						$(this).closest('.find-locally').find('.search-area.type-direction .to div.input').text(address);

						self.setDirection(self.activeItem);
					});
					$('.GPC0108').on('click', '.search-area.type-direction .close a', function(e) {
						e.preventDefault();

						var itemNum = self.activeItem;

						// for design
						self.$resultBox.addClass('active');
						self.$directionBox.removeClass('active');
						// 20200421 START 박지영 - 삭제
						// 20200421 END
						self.$localStore.find('.search-results .search-area.type-direction').removeClass('active');

						self.directionsDisplay.setMap(null);
						self.directionsDisplay.setPanel(null);

						for (var i = 0; i < self.markers.length; i++) {
							if (!self.markers[i].getVisible()) {
								self.markers[i].setVisible(true);
							}
						}
						self.$resultBox.find('.tabs-cont.active div.list-box[data-item='+itemNum+'] .view-detail-map').trigger('click');;
						self.openDirection = false;

						$('#startInput').val('');
					});

					self.$locationBtn.on('click', function(e) {
						e.preventDefault();
						self.getMyLocation();
					});

					//layer toggle event
					self.$toggleBtn.on('click', function(e) {
						e.preventDefault();
						var list = self.$storeSection;
						// 20200323 START 박지영 : 검색 결과 닫아 놓고 지도 드래그 시 발생하는 오류 수정
						if(!list.hasClass('active')) {
							list.addClass('active');
							self.$localStore.find('.search-results').addClass('active');
						} else {
							list.removeClass('active');
							self.$localStore.find('.search-results').removeClass('active');
						}
						// 20200323 END
					});
					//tab toggle event
					self.$storeSearchForm.on('submit', $.proxy(self.searchAddress, self));
					self.$directionsForm.on('submit', $.proxy(self.setDirectionPanel, self));

					// for ae
					//if(self.options.autoSubmit) {
					//	self.$storeSearchForm.submit();
					//}

					// for ae and levant
					self.$countryCombo.on('change', function(e) {
						self.options.country = ($(this).val() != '') ? $(this).val() : null;

						if(self.hasSearchSubmit) return;

						if(!self.options.autoSubmit) {
							self.mapSetting();
						}
						if (!self.hasSearchInput) {
							// for ae
							self.$storeSearchForm.submit();
						}  else if(COUNTRY_CODE == 'eastafrica'){
							//LGEEASTAF-161
							self.$searchInput.val('');
							self.$storeSearchForm.submit();
						} else {
							// for levent
							// 20200421 START 박지영 - levant 수정
							$('#mapSearch').val('');
							self.$resultBox.addClass('active');
							self.$brandList.removeClass('active');
							self.$directionBox.removeClass('active');
							self.$defaultMsg.addClass('active')
							// 20200421 END
						}
					});

					// for eg
					self.$stepCity.on('change', function(e) {
						// 20200421 START 박지영 - levant 수정
						//if(self.hasSearchSubmit) return;
						$('#mapSearch').val('');
						// 20200421 END
						self.$storeSearchForm.submit();
					});
					
					// LGETR-385 Start
					self.$trProvince = self.$localStore.find('select[id=trProvince]');
					self.$trProvince.on('change', function() {
						$(this).closest(".select-box").removeClass("error");
						
						self.trProvince = $(this).val();
						self.$storeSearchForm.find('input[name=stateName]').val(self.trProvince);
						self.$storeSearchForm.find('input[name=cityName]').val("");
						self.keyword.value='';
					});
					
					self.$trCity = self.$localStore.find('select[id=trCity]');
					self.$trProvince.drawAjaxOptions({
		                url: $(this).data('url'),
		                setTarget: document.getElementById("trCity"),
		                dynamicParam: true, // true 이면, select 의 data-param 값을 가져옴
		                callback: function(data) {
		                	self.$trCity.val('all');
		                	self.$trCity.trigger("chosen:updated");
		                	self.$trCity.trigger('change');
		                }
		            });
					
					self.$trCity.on('change', function(e) {
						self.keyword.value='';
						
						self.trCity = $(this).val();
						self.$storeSearchForm.find('input[name=cityName]').val(self.trCity);
					});
					
					self.$category = self.$localStore.find('select[id=category]');
					self.$category.on('change', function() {
						self.category = $(this).val();
						self.$storeSearchForm.find('input[name=categoryId]').val(self.category);
					});
					// LGETR-385 End

					// 20200421 START 박지영 - 불필요한 코드 삭제
					// 20200421 END
					// submit button
					self.$localStore.find('.searchbox form .submit-box button.btn.btn-primary').on('click', function(e) {
						e.preventDefault();
						
						// LGETR-385 Start 
						if(COUNTRY_CODE == "tr"){
							if(self.$storeSearchForm.find('input[name=stateName]').val() == ""){
								self.$trProvince.focus();	
								self.$trProvince.closest('.select-box').addClass("error");
								return;
							}
							
							if(self.$storeSearchForm.find('input[name=cityName]').val() == "all"){
								self.$storeSearchForm.find('input[name=cityName]').val("");
							}
							if(self.$storeSearchForm.find('input[name=categoryId]').val() == "all"){
								self.$storeSearchForm.find('input[name=categoryId]').val("");
							}
						}
						// LGETR-385 End

						// for design
						self.$resultBox.addClass('active');
						self.$directionBox.removeClass('active');
						self.$localStore.find('.search-results').addClass('active');
						// 20200421 START 박지영 - 불필요한 코드 삭제
						// 20200421 END
						self.$localStore.find('.search-results .search-area.type-direction').removeClass('active');

						// if (self.$countryCombo.length > 0 && self.hasSearchInput) {
						// 20200421 START 박지영 - country 선택되어야 지도 업데이트 하도록 수정
						if (self.$countryCombo.length > 0 && self.options.country != null) {
							// for levent and ae
							self.mapSetting();
						}
						// 20200421 END
						self.$storeSearchForm.submit();
					});

					// toggle category
					self.$storeSection.on('click', '.list-box .category-area .category a', function(e) {
						e.preventDefault();
						e.stopPropagation();
						if(self.$brandList.hasClass('mCustomScrollbar')) self.$brandList.mCustomScrollbar('destroy');
						var $cont = $(this).closest('.category-area');
						var txt;
						if($cont.hasClass('active')) {
							$cont.removeClass('active');
							$(this).attr('aria-expanded', false);
							txt = $(this).data('show-msg');
						} else {
							$cont.addClass('active');
							$(this).attr('aria-expanded', true);
							txt = $(this).data('hide-msg');
						}
						$(this).text(txt);
						if($(this).closest('.list').hasClass('slick-initialized')) {
							var sumH = 0;
							for(i=0;i<$(this).closest('.slick-current').find('.list-box').length;i++) {
								sumH = sumH + parseInt($(this).closest('.slick-current').find('.list-box').eq(i).outerHeight());
								console.log(parseInt($(this).closest('.slick-current').find('.list-box').eq(i).outerHeight()), sumH);
							}
							$(this).closest('.slick-list').css('height', sumH);
						}
						return false;
					});
				},
				getMyLocation : function() {
					var self = this;
					if ($(this).siblings('input[type=text]').attr('disabled') == 'disabled') {return;}

					self.geocoder = new google.maps.Geocoder;
					function geoError(error) {
						console.log(err.code, err.message);
						// alert('Geolocation is not supported for this Browser/OS.');
						if($('#geoLocationError').length>0) $('#geoLocationError').modal();
					}
					if (self.options.country == null) {
						// no country
						self.$brandList.removeClass('active');
						self.$defaultMsg.addClass('active');
						self.$noItems.removeClass('active');
						self.$btnArea.removeClass('active');
						return;
					}
					if (navigator.geolocation) {
						navigator.geolocation.getCurrentPosition(function(position) {
							var latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
							self.geocoder.geocode({
								"location": latLng,
								"region": self.options.country
							}, $.proxy(function(results, status) {
								if (status == google.maps.GeocoderStatus.OK) {
									var geom = results[0].geometry,
										address = results[0].formatted_address,
										viewport = geom.viewport;
									var myform = $(this).closest('form');
									if(!self.openDirection) self.$searchInput.val(address);
									else $(self.locaitonKey).val(address);
									self.map.fitBounds(viewport);
									self.center = self.map.getCenter();
									if(!self.openDirection) self.$storeSearchForm.submit();
									else self.$directionsForm.submit();
								}
							}, self));
						}, geoError, {enableHighAccuracy: true, timeout:1000});
					} else {
						geoError();
					}
				},
				mapSetting : function() {
					var self = this;
					self.mapDiv = document.getElementById("storeMap");
					self.keyword = document.getElementById("mapSearch");
					self.mapOptions = {
						zoom: (firstTime) ? self.options.zoomLevel : self.map.getZoom(),
						mapTypeId: google.maps.MapTypeId.ROADMAP,
						// 20200429 START 박지영 - RTL 옵션 반영
						mapTypeControl: false,
						mapTypeControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.RIGHT_TOP : google.maps.ControlPosition.LEFT_TOP
						},
						panControl: false,
						panControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.LEFT_TOP : google.maps.ControlPosition.RIGHT_TOP
						},
						zoomControl: true,
						zoomControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.LEFT_BOTTOM : google.maps.ControlPosition.RIGHT_BOTTOM
						},
						scaleControl: false,
						scaleControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.LEFT_TOP : google.maps.ControlPosition.RIGHT_TOP
						},
						streetViewControl: true,
						streetViewControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.LEFT_BOTTOM : google.maps.ControlPosition.RIGHT_BOTTOM
						},
						fullscreenControl: true,
						fullscreenControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.LEFT_TOP : google.maps.ControlPosition.RIGHT_TOP
						},
						// 20200429 END
						minZoom: self.options.zoomLevelMin,
						maxZoom: self.options.zoomLevelMax
					}
					self.infoOptions = {
						disableAutoPan: true,
						alignBottom: true,
						pixelOffset: new google.maps.Size(-162, -54),
						zIndex: 99,
						boxStyle: {
							width: ($(window).width()<768) ? "300px":"360px"
						},
						infoBoxClearance: new google.maps.Size(1, 1),
						enableEventPropagation: true,
						boxClass:  ($(window).width()<768) ? "info-window small" : "info-window"
					};
					self.map = new google.maps.Map(self.mapDiv, self.mapOptions);
					self.infoBox = new InfoBox(self.infoOptions);
					self.directionService = new google.maps.DirectionsService();
					self.directionsDisplay = new google.maps.DirectionsRenderer();
					self.mapControl();
					self.center = self.map.getCenter();
					// 20200409 START 박지영 : 전달 값을 명확하게 변경
					if (firstTime) {
						// REQ-048
						if(!self.options.defaultLatitude || !self.options.defaultLongitude) {
							firstTime = false;
							self.setCountry(self.options.country, 'country');
							if(parseInt(self.options.defaultZoom) > 0) self.map.setZoom(parseInt(self.options.defaultZoom));
							// 20200421 START 박지영 - input이 있는 경우에만 실행하도록 수정
							if(self.keyword) self.autoZipcode(self.keyword);
							// 20200421 END
						} else {
							var pos = new google.maps.LatLng(self.options.defaultLatitude, self.options.defaultLongitude);
							self.setCountry(pos, 'latlng');
							if(parseInt(self.options.defaultZoom) > 0) self.map.setZoom(parseInt(self.options.defaultZoom));
							// 20200421 START 박지영 - input이 있는 경우에만 실행하도록 수정
							if(self.keyword) self.autoZipcode(self.keyword);
							// 20200421 END
						}
					} else {
						self.setCountry(self.options.country, 'country');
						// 20200421 START 박지영 - input이 있는 경우에만 실행하도록 수정
						if(self.keyword) self.autoZipcode(self.keyword);
						// 20200421 END
					}
					// 20200409 END
					
					/* LGESA-304 Start */
					google.maps.event.addListenerOnce(self.map, 'idle', function(){
						if(!!self.$localStore.data('default-locally-keyword') && self.$localStore.data('default-locally-keyword') != 'component-default-locally-keyword' && self.$localStore.data('default-locally-keyword') != ''){
							self.$searchInput.val(self.$localStore.data('default-locally-keyword'));
							setTimeout(function(){
								self.searchAddress();
							}, 1000)
						}
					});
					/* LGESA-304 End */
				},
				//autocomplet input
				autoZipcode : function(element) {
					// 20200413 START 박지영
					$('.pac-container').remove();
					// 20200413 END
					var self = this;
					// 20200421 START 박지영 - country 선택되지 않으면 실행 안되도록 수정
					if(!self.options.country) return false;
					// 20200421 END
					self.autoCompleteOption = {
						componentRestrictions: {
							country: self.options.country
						}
					};
					self.autoComplete = new google.maps.places.Autocomplete(element, self.autoCompleteOption);
					/* do not use this on Brand Shop
					google.maps.event.addListener(self.autoComplete, 'place_changed', $.proxy(function(e) {
						var place = self.autoComplete.getPlace();
						if (!self.openDirection) {
							self.$storeSearchForm.submit();
						}
					}, self));
					*/
				},
				mapControl : function() {
					var self = this;
					//drag event
					google.maps.event.addListener(self.map, 'dragend', $.proxy(function(e) {
						self.center = self.map.getCenter();
						if (!self.openDirection) {
							if (self.afterControl) {
								self.getStore();
								self.setRestrictionByGeocode(self.center)
							}
						}
						google.maps.event.trigger(self.map, "resize");
					}, self));
				},
				queryData : function() {
					var self = this;
					if (self.map.getZoom() < self.options.queryZoomLevel) {
						self.map.setZoom(self.options.queryZoomLevel);
					}
					/* LGEEG-399 start */
					if(firstLoadAllShop && ( COUNTRY_CODE=='eg_en' || COUNTRY_CODE=='eg_ar' )){
						self.map.setZoom(6);	// for full map
					}
					/* LGEEG-399 end */
					//self.reset();
					self.dataque = self.$storeSearchForm.serialize() + "&" + $.param({
						lat: self.map.getCenter().lat(),
						lng: self.map.getCenter().lng(),
						zipCode: self.options.country,
						zoomLevel: (self.map.getZoom()) ? self.map.getZoom() : 10
					});
					if(self.$countryCombo.length>0) {
						self.dataque = self.dataque + "&" + $.param({
							country: self.$countryCombo.val()
						});
					}
					if(self.$stepCity.length>0) {
						self.dataque = self.dataque + "&" + $.param({
							stepCity: self.$stepCity.val()
						});
					}
					// 20200421 START 박지영 - 불필요한 코드 삭제 
					// 20200421 END
					/* LGEEG-399 start */
					if(firstLoadAllShop && ( COUNTRY_CODE=='eg_en' || COUNTRY_CODE=='eg_ar' )){
						firstLoadAllShop = false;
						self.dataque = self.dataque + "&" + $.param({
							firstLoadAllShop : "Y"
						});
					}
					/* LGEEG-399 end */
					//console.log('self.dataque', self.dataque);
					self.center = self.map.getCenter();
					self.clearMarker();
					// 20200421 START 박지영 - 로딩 이미지 적용
					$('.GPC0108 .map-container').trigger('ajaxLoadBefore');
					// 20200421 END
					$.ajax({
						type: self.$searchForm.attr('method'),
						url: self.options.queryUrl,
						data: xssfilter(self.dataque),
						dataType: self.options.queryType,
						error: function(xhr) {
							//self.reset();
							self.setErrorList();
							//console.log(xhr);
						},
						success: function(d) {
							self.map.process = true;
							self.markers = [];
							self.stores = [];
							var data = d instanceof Array ? d : d.data;
							data.marker = ""; //LGEGMC-2455

							if (data.length) {
								var curBounds = new google.maps.LatLngBounds();
								var insetMarker = 0;

								//list reset
								self.$brandList.addClass('active');
								self.$brandList.siblings('.btn-area').removeClass('active');
								self.$brandList.siblings('.default-msg').removeClass('active');
								self.$brandList.siblings('.no-items').removeClass('active');

								// 20200525 START 박지영 - 모바일 화면에서 오류 수정
								self.$brandList.find('.list').remove();
								self.$brandList.html('<div class="list"></div>');
								// 20200525 END

								self.$brandList.data('brand-count', 0);

								// 20200421 START 박지영 : 검색 결과 닫아 놓고 지도 드래그 시 발생하는 오류 수정
								self.$localStore.find('.search-results').addClass('active');
								// 20200421 END

								$.each(data, function(item) {
									var latlng = new google.maps.LatLng(data[item]['wtbLatitudeValue'], data[item]['wtbLongitudeValue']);
									// 20200421 START 목록이 100개 이상일때 100개부터 적용할 아이콘 추가
									if(item>=100) {
										self.markerIcon.url = "/lg5-common-gp/images/customer/mark-00.png";
									} else {
										self.markerIcon.url = "/lg5-common-gp/images/customer/mark-" + (parseInt(item, 10) + 101).toString().substr(1) + ".png";
									}
									// 20200421 END
									var curMarker = $.extend(true, {}, self.markerIcon);
									self.addMarkers(latlng, curMarker, item);
									self.stores.push(data[item]);
									self.setRepairList(data, item);
									setTimeout(function() {
										scrollDesign();
									}, 300);
									curBounds.extend(latlng);
									insetMarker += self.map.getBounds().contains(latlng) ? 1 : 0;
								});

								if(self.$brandList.data('brand-count') == 0) {
									self.$brandList.removeClass('active');
									self.$brandList.siblings('.btn-area').removeClass('active');
									self.$brandList.siblings('.default-msg').removeClass('active');
									self.$brandList.siblings('.no-items').addClass('active');
								}

								// bind event
								self.$resultBox.find('.list-box .view-detail-map').off('click').on('click', function(e) {
									e.preventDefault();
									e.stopPropagation();

									self.infoBox.close();
									var item = $(this).closest('.list-box').data('item');
									self.activeItem = item;
									if ($(window).width()>=768) {
										//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 start
										self.offsetCenter(self.markers[item].getPosition(), 0, -200, self.map);
									} else {
										self.offsetCenter(self.markers[item].getPosition(), 0, -100, self.map);
									}
									// LGEGMC-2455 start
									if( !selectedMarker || selectedMarker !== self.markers[item] ) {
										if(!!selectedMarker) {
											selectedMarker.icon.url = resetIcon;
											resetIcon = "/lg5-common-gp/images/customer/mark-" + (parseInt(item, 10) + 101).toString().substr(1) + ".png";
										} else {
											self.markers[item].setOptions({
												zIndex: 1
											});
											resetIcon = self.markers[item].icon.url;
										}
										clickIcon = "/lg5-common-gp/images/customer/mark-" + (parseInt(item, 10) + 101).toString().substr(1) + "-active.png";
										self.markers[item].icon.url = clickIcon;
										self.markers[item].icon.scaledSize= new google.maps.Size(30, 43);
										if(self.markers[item].icon.url.includes('active')) {
											self.markers[item].setOptions({
												zIndex: 99
											});
										}
									}
									selectedMarker = self.markers[item];
									// LGEGMC-2455 end
									self.setStoreInfo(self.stores, self.infoBox, item);		
									self.infoBox.open(self.map, self.markers[item]);
									
									//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 start
									if($(window).width()<768) {
										if($cont.find('#wtbScrollFlag').val() == 'Y') {
											var componentId = $('.GPC0108');
		                                    self.scrolling(self.getScrollPostion(componentId, 1));
										}	
									}
                                    //LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 end
                                    
									self.$resultBox.find('.list-box').not($(this).closest('.list-box')).removeClass('active');
									$(this).closest('.list-box').addClass('active');
								});

								if ($(window).width()<768) {
									self.$storeSection.addClass('active');
								} else {
									setTimeout(function() {
										self.$storeSection.addClass('active');
									}, 200);
								}
								self.$storeSection.addClass('active');
								self.zoom = self.map.getZoom();
								if (self.searchHandle && insetMarker < Math.min(2, data.length)) {
									var minBounds = new google.maps.LatLngBounds();
									for (var k = 0; k < Math.min(2, data.length); k++) {
										var _latlng = new google.maps.LatLng(data[k]['wtbLatitudeValue'], data[k]['wtbLongitudeValue']);
										minBounds.extend(_latlng);
									}
									setTimeout(function() {
										google.maps.event.addListenerOnce(self.map, 'bounds_changed', function(event) {
											if (self.map.getZoom() > 17) {
												self.map.setZoom(17);
											}
										});
										var _latlng = new google.maps.LatLng(self.map.getCenter().lat(), self.map.getCenter().lng());
										minBounds.extend(_latlng);
										self.map.fitBounds(minBounds)
										self.offsetCenter(self.markers[0].getPosition(), 0, 0, self.map);
									}, 350);
								} else if (self.searchHandle && insetMarker >= Math.min(2, data.length)) {
									self.offsetCenter(self.markers[0].getPosition(), 0, 0, self.map);
								}
								if ($(window).width()<768 && data.length>3) {
									// 20200421 START 박지영 - 주석 삭제
									// console.log('item long---')
									// 20200421 END
									// brand list for mobile
									if(self.$brandList.data('brand-count')>3) {
										self.$brandList.siblings('.btn-area').addClass('active');
										setTimeout(function() {
											var $ele2 = self.$brandList.find('.list');
											$ele2.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
												var i = (currentSlide ? currentSlide : 0) + 1;
												self.$brandList.siblings('.btn-area').find(".total-page").text(slick.slideCount);
												self.$brandList.siblings('.btn-area').find(".current-page").text(i);
											});
											$ele2.slick({
												adaptiveHeight: true,
												rows: 3,
												slidesPerRow: 1,
												infinite: false,
												dots: false,
												speed: 500,
												prevArrow: ".pagination .prev",
												nextArrow: ".pagination .next"
											});
										}, 500);
									}
								}
							} else {
								if(d.businessErrorFlag=="Y" && d.redirectUrl != null) {
									location.href=d.redirectUrl;
								} else {
									//self.reset();
									self.setErrorList();
								}
							}
							self.map.process = false;
						},
						complete: function() {
							self.searchHandle = false;
							// 20200421 START 박지영 - 로딩 이미지 적용
							$('.GPC0108 .map-container').trigger('ajaxLoadEnd');
							// 20200421 END
						}
					})
				},
				getStore : function(force) {
					var self = this;
					clearTimeout(self.timing.queryTimeout);
					//console.log(!self.infoBox.getVisible());
					if (!self.infoBox.getVisible() || force) {
						self.reset();
						self.timing.queryTimeout = setTimeout($.proxy(self.queryData, self), 200);
					}
				},
				// 20200409 START 박지영 : 전달 값을 명확하게 변경
				setCountry : function(address, dir) {
					var self = this;
					self.geocoder = new google.maps.Geocoder;
					var slocation = {};
					// 20200421 START 박지영 - 조건 수정
					if(dir=='latlng') { // self.openDirection || 
					// 20200421 END
						slocation = {"location": address}
					} else if(dir=='country') {
						slocation = {"componentRestrictions": {"country":address}}
 					} else {
						slocation = {"address": address}
					}
					self.geocoder.geocode(slocation, $.proxy(function(results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							self.geoResult.locations = results[0].geometry.location;
							if (self.openDirection || firstTime) { // REQ-048
								self.offsetCenter(self.geoResult.locations, 0, 0, self.map);
								firstTime=false; // REQ-048
							} else {
								self.offsetCenter(self.geoResult.locations, 220, -100, self.map);
							}
							if ($(window).width()<768) self.offsetCenter(self.geoResult.locations, 100, -80, self.map);
						}
					}, this));
				},
				// 20200409 END
				addMarkers : function(latlng, marker, itemNum) {
					var self = this;
					var bounds = new google.maps.LatLngBounds();
					var currMarker = self;

					var marker = new google.maps.Marker({
						map: self.map,
						icon: marker,
						draggable: false,
						position: latlng,
						zIndex: 1
					});

					marker.setVisible(true);
					self.markers.push(marker);

					google.maps.event.addListener(marker, "click", function(e) {
						// LGEGMC-2455 start
						if( !selectedMarker || selectedMarker !== marker ) {
							if(!!selectedMarker) {
								selectedMarker.icon.url = resetIcon;
								resetIcon = "/lg5-common-gp/images/customer/mark-" + (parseInt(itemNum, 10) + 101).toString().substr(1) + ".png";
							} else {
								resetIcon = marker.icon.url;
							}
							clickIcon = "/lg5-common-gp/images/customer/mark-" + (parseInt(itemNum, 10) + 101).toString().substr(1) + "-active.png";
							marker.icon.url = clickIcon;
							marker.icon.scaledSize= new google.maps.Size(30, 43);
						}
						selectedMarker = marker;
						// LGEGMC-2455 end
						self.infoBox.open(self.map, this);
						self.onItem(itemNum);
						self.focusList(itemNum);
						// LGEGMC-2455
						this.setOptions({
							zIndex: 99
						});
					});

					google.maps.event.addListener(marker, 'mouseover', function() {
						this.setOptions({
							zIndex: 9
						});
					})
				},
				offsetCenter : function(latlng, offsetx, offsety, map) {
					var self = this;
					var scale = Math.pow(2, map.getZoom());
					var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
					var pixelOffset = new google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0);
					var worldCoordinateNewCenter = new google.maps.Point(worldCoordinateCenter.x - pixelOffset.x, worldCoordinateCenter.y + pixelOffset.y);
					var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
					map.panTo(newCenter);
				},
				//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 start
				getScrollPostion : function(tg){
					var offsetTop = Math.round(tg.offset().top);

					tg.hasClass("iw_placeholder") || 
					tg.find(".iw_placeholder").length > 0 || 
					tg.closest(".iw_placeholder").length > 0 

					return offsetTop;
				},
				scrolling : function (pos){
					$('html, body').animate({
						scrollTop: pos
					//}, "fast");
					},{duration:500});// LGEITF-428
				},
				//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 end
				setStoreInfo : function(data, self, itemNum) {
					var data = data[itemNum];
					
					//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 start
					var categoryString = "";
					if(!!data["superCategory"]) {
						if($cont.find('#wtbTitleFlag').val() == 'Y'){
		                    var strSuper = data["superCategory"].split(",");								
		                    const set = Array.from(new Set(strSuper));

		                    for(var c1 = 0; c1 < set.length; c1++) {
		                    	var supCategory = '<span class="bold">' + "ㆍ" + set[c1] + '</span>';

		                        var products = " : " + data["categoryCode"][set[c1]] + "<br>";
		                        products = products.replace(/,/g, ", "); // LGEIN-702
		                        categoryString += supCategory.concat(products);
		                    }
						}
						else {
							categoryString = data["productCode"].join(', ');
						}
					}
					//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 end
					
					data["marker"] = this.getChangeMarker(itemNum); // LGEGMC-2455

					var content = this.templateMap
								.replace(/\*distance\*/g, data["distance"])
								.replace(/\*marker\*/g, data["marker"]) // LGEGMC-2455 
								.replace(/\*logo\*/g, (!data["logo"]) ? '/lg5-common-gp/images/common/product-default-list-165.jpg' : data["logo"])
								.replace(/\*wtbName\*/g, data["wtbName"])
								.replace(/\*address\*/g, data["address"])
								.replace(/\*addressLine1Info\*/g, data["addressLine1Info"])
								.replace(/\*pinCode\*/g, data["pinCode"])
								.replace(/\*stdCode\*/g, data["stdCode"])
								.replace(/\*wtbPhoneNo\*/g, data["wtbPhoneNo"])
								.replace(/\*wtbFaxNo\*/g, data["wtbFaxNo"])
								.replace(/\*wtbEmail\*/g, data["wtbEmail"])
								.replace(/\*wtbTime\*/g, data["wtbTime"])
								.replace(/\*wtbUrl\*/g, data["wtbUrl"])
								.replace(/\*productCode\*/g, categoryString)//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53
								;

					var $template = $(content),
						$keyBlocks = $template.find('*[data-key]');

					for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
						var $currentKeyBlock = $keyBlocks.eq(i1),
							key = $currentKeyBlock.get(0).getAttribute('data-key'),
							val = data[key];
						if(!val || val==null) {
							$currentKeyBlock.remove();
						}
					}

					var template = $template.get(0).outerHTML;
					self.setContent(template);
					//LGEGMC-2455 start
					setTimeout(function() {
						if($(window).width()<768) {
							if($(".info-window .info-window-wrap").hasClass('mCustomScrollbar')) $(".info-window .info-window-wrap").mCustomScrollbar('disable', true);
						} else {
							$(".info-window .info-window-wrap").mCustomScrollbar({
								theme:'dark',
							});
							if (($(".info-window .info-window-wrap .mCustomScrollBox").attr('style')).includes('none')) $(".info-window .info-window-wrap").mCustomScrollbar('disable', true);
						}
					}, 100);
					//LGEGMC-2455 end
				},
				// LGEGMC-2455 start
				getChangeMarker : function(itemNum) {
					if(itemNum>=100) {
						return "/lg5-common-gp/images/customer/mark-00-active.png";
					} else {
						return "/lg5-common-gp/images/customer/mark-" + (parseInt(itemNum, 10) + 101).toString().substr(1) + "-active.png";
					}
				},
				// LGEGMC-2455 end
				searchAddress : function(e) {
					var self = this,
						address = self.$searchInput.val(),
						$searchEle = self.$searchForm.find("select, input"),
						geocoderOptions;

					self.geocoder = new google.maps.Geocoder;
					/* LGESA-304 Start */
					if(!!e) e.preventDefault();
					/* LGESA-304 End */
					
					if (self.options.country == null) {
						// no country
						self.$brandList.removeClass('active');
						self.$defaultMsg.addClass('active');
						self.$noItems.removeClass('active');
						self.$btnArea.removeClass('active');
						// 20200421 START 박지영 - 코드수정
						return false;
						// 20200421 END
					} else {
						// 20200421 START 박지영 - 5차 국가 반영 
						if(self.$countryCombo.length>0) {
							// ae, levant, africa
							if(self.hasSearchInput){
								// levant, africa
								if(self.$searchInput.val()==""||self.$searchInput.val()==null){
									geocoderOptions = {
										"address":self.options.country,
										componentRestrictions: {
											"country": self.options.country
										}
									};
								} else {
									geocoderOptions = {
										"address": self.$searchInput.val(),
										"region": self.options.country
									};
								}
							} else {
								// ae
								geocoderOptions = {
									"address":self.options.country,
									componentRestrictions: {
										"country": self.options.country
									}
								};
							}
						} else if (self.$stepCity.length > 0) {
							// EG
							if(self.$searchInput.val()==""||self.$searchInput.val()==null){
								if(self.$stepCity.val()=="Others"){
									//self.$searchInput.parents("li[class*=step]").addClass("open-tooltip")
									//return;
								}
								/* LGEEG-399 start */
								if(firstTime && ( COUNTRY_CODE=='eg_en' || COUNTRY_CODE=='eg_ar' )){
									geocoderOptions = {
											"address": self.$stepCity[0].options[1].value,
											"region": self.options.country
										};
								}else{
								/* LGEEG-399 end */
									geocoderOptions = {
										"address": self.$stepCity.val(),
										"region": self.options.country
									};
								}	// LGEEG-399 add
							} else {
								self.$stepCity.find("option:last-child").prop("selected", true).trigger("chosen:updated");
								geocoderOptions = {
									"address": self.$searchInput.val(),
									"region": self.options.country
								};
							}
						} else if(self.$searchInput.length>0 && self.$searchInput.is(':visible')) {
							// Default
							geocoderOptions = {
								"address": self.$searchInput.val(),
								"region": self.options.country
							};
							
						// LGETR-385 Start
						} else if(self.$trProvince.length>0) {
							geocoderOptions = {
								"address":self.$storeSearchForm.find('input[name=stateName]').val()
							};

						// LGETR-385 End
						} else {
							geocoderOptions = {
								"address": self.options.country
							};
						}
						// 20200421 END
					}

					//console.log(geocoderOptions);
					// 20200421 START 박지영 - 수정 및 코드 정리
					//if(address == 'null' || address == null) return;

					self.geocoder.geocode(geocoderOptions, function(results, status) {
					// 20200421 END
						if (status == google.maps.GeocoderStatus.OK) {

							//console.log('submit');
							var geom = results[0].geometry,
								location = geom.location,
								address = results[0].formatted_address,
								viewport = geom.viewport;
							self.center = self.map.getCenter();
							self.results = results[0].address_components;
							self.zipcode;
							for (var i = self.results.length - 1; i > -1; i--) {
								self.address = self.results[i];
								if (self.address.types[0] == "postal_code") {
									self.zipcode = self.address.long_name;
									break;
								}
							}
							var markerOptions = {
								position: location,
								title: address,
								animation: google.maps.Animation.DROP
							};

							self.$resultLocation.text(address);
							self.map.fitBounds(viewport);
							self.afterSearch();
							self.afterControl = true;

							//var product = ($('#repairProduct').find('option:selected').text());
							//product = changeTitleFormat(product);
							//address = changeTitleFormat(address);
							//adobeTrackEvent('cs-find-service-center-submit', {service_center_location : address, service_center_search_product : product, page_event : {service_center_search : true}});

						} else {
							self.reset();
							self.setErrorList();
							self.afterControl = false;
						}
					});

					var slist = $(".store-list", self.$storeSearchForm);
					if($('.navigation').length>0 && !$('.navigation').is('.mobile-device')) {
						setTimeout(function() {
							if($(window).width()<768) {
								if(slist.hasClass('mCustomScrollbar')) slist.mCustomScrollbar('disable', true);
							} else {
								//if(slist.hasClass('mCustomScrollbar')) slist.mCustomScrollbar('disable', false);
								if(slist.hasClass('mCustomScrollbar')) slist.mCustomScrollbar('update');
							}
						}, 500);
					}
				},
				afterSearch : function() {
					var self = this;
					self.reset();
					self.searchHandle = true;
					self.distance = 25;
					self.getStore();
				},
				// 20200326 START 이지원 slick pagination focus 수정
				focusList : function(item, callback) {
					//console.log(item);
					if($('.navigation').length>0){
						var tabActive = $('.tabs-cont.active'),
							resultList = tabActive.find('.result-list'),
							slist = resultList.find('.list'),
							currentPage = Math.floor(item / 3),
							dontAnimate = true;

						if(!$('.navigation').is('.mobile-device')){
							var currentItem = slist.find('.list-box[data-item="'+item+'"]');
							resultList.mCustomScrollbar('scrollTo', currentItem);
						} else {
							if (item >= 0 && item < 3) {
								slist.slick('slickGoTo', 0, dontAnimate)
							} else {
								slist.slick('slickGoTo', currentPage, dontAnimate);
							}
						}
					}
				},
				// 20200326 END
				onItem : function(item) {
					//console.log('onItem', item, typeof(item));
					var self = this;
					$("div.list-box", "#storeResult").removeClass("active").filter("div.list-box[data-item='" + item + "']").addClass("active");
					$("div.list-box", "#brandResult").removeClass("active").filter("div.list-box[data-item='" + item + "']").addClass("active");

					if (typeof(self.infoBox) != "undefined") {
						if (typeof(item) == "undefined" || item == "undefined") {
							self.infoBox.close();
							self.activeItem = null;
						} else if (self.activeItem != item) {
							self.infoBox.close();
							self.activeItem = item;
							if ($(window).width()>=768) {
								//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53
								self.offsetCenter(self.markers[item].getPosition(), 0, -200, self.map);
							} else {
								self.offsetCenter(self.markers[item].getPosition(), 0, -100, self.map);
							}
							self.setStoreInfo(self.stores, self.infoBox, item);										
							self.infoBox.open(self.map, self.markers[item]);
						} else if (self.activeItem == item && !self.infoBox.getVisible()) {
							self.infoBox.Content(null);
							self.offsetCenter(self.markers[item].getPosition(), 0, -100, self.map);
							self.setStoreInfo(self.stores, self.infoBox, item);		
							self.infoBox.open(self.map, self.markers[item]);
						}
					}
				},
				setDirection : function(item) {
					var self = this;
					var startInput = document.getElementById("startInput");
					self.$routeList.html(null);

					if (self.openDirection) {

						var data = self.stores[item];
						for (var i = 0; i < self.markers.length; i++) {
							if (self.markers[i].getVisible()) {
								self.markers[i].setVisible(false);
							}
						}
						self.markers[item].setVisible(true);
						self.directionAutocomplete = new google.maps.places.Autocomplete(startInput, self.autoCompleteOption);
						google.maps.event.addListener(self.directionAutocomplete, 'place_changed', $.proxy(function(e) {
							self.$directionsForm.submit();
						}, self));

						self.$routeList.removeClass('active');
						self.$routeList.siblings('.direction-title').removeClass('active');
						self.$routeList.siblings('.default-msg').addClass('active');
						self.$routeList.siblings('.no-items').removeClass('active');

					}
				},
				setDirectionPanel : function(e) {

					e.preventDefault();
					var self = this;

					var routeList = document.getElementById("directionRoute");
					var unit = self.options.unitMetric ? google.maps.UnitSystem.METRIC : google.maps.UnitSystem.IMPERIAL;
					var origin = self.directionAutocomplete.getPlace();
					var destination = self.markers[self.activeItem].getPosition();

					if(typeof(origin) == "undefined"){
						return;
					}

					if (!origin.geometry) {
						self.$routeList.removeClass('active');
						self.$routeList.siblings('.direction-title').removeClass('active');
						self.$routeList.siblings('.default-msg').removeClass('active');
						self.$routeList.siblings('.no-items').addClass('active');
						return;
					}
					self.$routeList.addClass('active');
					self.$routeList.siblings('.direction-title').addClass('active');
					self.$routeList.siblings('.default-msg').removeClass('active');
					self.$routeList.siblings('.no-items').removeClass('active');

					var directionRoute = {
						origin: origin.geometry.location,
						destination: destination,
						travelMode: google.maps.TravelMode.DRIVING,
						unitSystem: unit
					};
					if (self.directionsDisplay) {
						self.directionsDisplay.setMap(self.map);
						self.directionsDisplay.setPanel(routeList);
					}

					self.directionService.route(directionRoute, function(response, status) {
						if (status == google.maps.DirectionsStatus.OK) {
							self.directionsDisplay.setDirections(response);
							for (var i = 0; i < self.markers.length; i++) {
								if (self.markers[i].getVisible())
									self.markers[i].setVisible(false);
							}
							self.infoBox.close();
						} else {
							self.directionsDisplay.setMap(null);
							self.directionsDisplay.setPanel(null);
						}
					});
				},
				//query string ascPostalCode make
				setRestrictionByGeocode : function(loc) {
					var self = this;
					self.geocoder.geocode({
						'location': loc
					}, function(results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							self.results = results[0].address_components;
							for (var i = self.results.length - 1; i > -1; i--) {
								self.address = self.results[i];
								if (self.address.types[0] == "postal_code") {
									self.zipcode = self.address.long_name;
									break;
								}
							}

						}
					});
				},
				clearMarker : function(map) {
					var self = this;
					for (var i = 0; i < self.markers.length; i++) {
						self.markers[i].setMap(null);
					}
					self.markers = [];
				},
				setRepairList : function(data, itemNum) {
					var self = this;
					var data = data[itemNum];
					
					//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 start
					var categoryString = "";
					if(!!data["superCategory"]) {
						if($cont.find('#wtbTitleFlag').val() == 'Y'){
		                    var strSuper = data["superCategory"].split(",");								
		                    const set = Array.from(new Set(strSuper));

		                    for(var c1 = 0; c1 < set.length; c1++) {
		                    	var supCategory = '<span class="bold">' + "ㆍ" + set[c1] + '</span>';

		                        var products = " : " + data["categoryCode"][set[c1]] + "<br>";
		                        products = products.replace(/,/g, ", "); // LGEIN-702
		                        categoryString += supCategory.concat(products);
		                    }
						}
						else {
							categoryString = data["productCode"].join(', ');
						}
					}
					//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 end
					var content = self.templateList
								.replace(/\*itemNum\*/g, itemNum)
								.replace(/\*itemNum2\*/g, (parseInt(itemNum)+1))
								.replace(/\*distance\*/g, data["distance"])
								.replace(/\*logo\*/g, (!data["logo"]) ? '/lg5-common-gp/images/common/product-default-list-165.jpg' : data["logo"])
								.replace(/\*wtbName\*/g, data["wtbName"])
								.replace(/\*address\*/g, data["address"])
								.replace(/\*addressLine1Info\*/g, data["addressLine1Info"])
								.replace(/\*pinCode\*/g, data["pinCode"])
								.replace(/\*stdCode\*/g, data["stdCode"])
								.replace(/\*wtbPhoneNo\*/g, data["wtbPhoneNo"])
								.replace(/\*wtbFaxNo\*/g, data["wtbFaxNo"])
								.replace(/\*wtbEmail\*/g, data["wtbEmail"])
								.replace(/\*wtbTime\*/g, data["wtbTime"])
								.replace(/\*wtbUrl\*/g, data["wtbUrl"])
								// 20200506 START 박지영 - 오타 수정
								.replace(/\*productCode\*/g, categoryString) //LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53
								// 20200506 END
								;

					var $template = $(content),
						$keyBlocks = $template.find('*[data-key]');

					for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
						var $currentKeyBlock = $keyBlocks.eq(i1),
							key = $currentKeyBlock.get(0).getAttribute('data-key'),
							val = data[key];
						if(!val || val==null) {
							$currentKeyBlock.remove();
						}
					}
					var template = $template.get(0).outerHTML;
					self.$brandList.data('brand-count', parseInt(self.$brandList.data('brand-count'))+1);
					self.$brandList.find('.list').append(template);

					// 20200421 START 박지영 - unslick 이 제대로 되지 않았던 버그 수정
					if(self.$brandList.find('.list').hasClass('slick-initialized')) {
						self.$brandList.find('.list').slick('unslick');
					}
					// 20200421 END
				},
				setErrorList : function() {
					var self = this;
					if (self.$searchInput.val() != "") {
						self.$brandList.removeClass('active');
						self.$defaultMsg.removeClass('active');
						self.$btnArea.removeClass('active');
						self.$noItems.addClass('active');
					}
				},
				//center distance tap event
				distanceHandler : function(e) {
					var self = this;
					var target = $(e.target);
					if (self.afterControl) {
						self.distance = target.parent().data("distance");
						self.getStore(true); // force:true
						e.preventDefault();
					}
					//console.log(self.distance);
				},
				reset : function() {
					var self = this;
					self.clearMarker();
					self.onItem();
					self.activeItem = null;

					if (typeof(self.infoBox) != "undefined") self.infoBox.close();
					self.infoBox.setContent(null);
					self.directionsDisplay.setMap(null);
					self.directionsDisplay.setPanel(null);
					self.$brandList.mCustomScrollbar("destroy");
					self.$brandList.find('.list').html('');
					self.$storeSection.addClass("active");
					self.$noItems.removeClass('active');
					self.$btnArea.removeClass('active');

					if(self.$brandList.hasClass('slick-slider') || self.$brandList.hasClass('slick-initialized')) {
						self.$brandList.slick('unslick');
						self.$brandList.removeClass('slick-slider').removeClass('slick-initialized');
					}

				},
				resizing : function() {
					var self = this;
					self.center = self.map.getCenter();
					google.maps.event.trigger(self.map, "resize");
					self.map.setCenter(self.center);
				}
			};
			GoogleMaps._init();
			
			// EASTAF-171 START
			if(COUNTRY_CODE == 'eastafrica'){ 
				
				var dataCountry = $('.find-locally').data('country').toLowerCase();
				var countryListYn = "N";
				
				$("#countryList").find("option").each(function(i) {
					if($(this).val() != "" && dataCountry == $(this).val()){
						countryListYn = "Y";
						return false;
					}
				});
				
						
				if(countryListYn == "N"){
					dataCountry = "ke";
				}
				
				$("#countryList").val(dataCountry).trigger('chosen:updated');
				$("#countryList").val(dataCountry).trigger('change');
					
			}
			// EASTAF-171 END
			
			/* LGEEG-399 start */
			if(COUNTRY_CODE=='eg_en' || COUNTRY_CODE=='eg_ar'){
				$('#storeSearchForm').submit();
			}
			/* LGEEG-399 end */
			
		};
		//if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
			var mapFlag = false;
			$(window).scroll(function() {
				var t= $('.GPC0108').eq(0).offset().top;
				var b= t + $('.GPC0108').eq(0).height();
				if(isInScreen(t, b)) {
					if(!mapFlag) {
						mapFlag = true;

						var script = document.createElement('script');
						//var region = $('.find-locally').data('country') ? $('.find-locally').data('country').toUpperCase() : 'KR';
						//script.src = '//maps.googleapis.com/maps/api/js?v=3.39&libraries=places&client=gme%2Dlgelectronicsinc1&callback=initialize&region='+region+'&language=' + document.documentElement.lang;
						// 20200427 START 박지영 - tw 국가 중국어 번체로 변경
						var lang = document.documentElement.lang;
						if(COUNTRY_CODE.toLowerCase() == 'tw') lang = "zh-TW";
						//LGCOMMA-39 Start
						var region = "KR";
						if(COUNTRY_CODE.toLowerCase() == 'ma') region = "MA"; 
						script.src = '//maps.googleapis.com/maps/api/js?v=3.39&libraries=places&client=gme%2Dlgelectronicsinc1&callback=initialize&region=' + region + '&language=' + lang;
						//LGCOMMA-39 End
						// 20200427 END
						document.body.appendChild(script);
					}
				}
			}).scroll();
		//}
	}

});